import RoleTypes from'../../../../../constants/RoleTypes';
import {EsignerRole, Regex} from '../../../../Common/Constant';
const retrieveAccountUserSetup = (faOptions, role, showDropdownFaInput, setFaOptions,setOfficeOptions) => {

  let ddlOptions = [];
  let officeList = [];
  if (faOptions){
    faOptions.forEach((v) => {
      if (!v.id) {
        return;
      }

      const faSplit = v.id.split('-');
      if(faSplit.length === 2 && faSplit[1] === '000'){
          officeList.push({label: faSplit[0] ,value: faSplit[0]});
      }
      const officeFaRegex = Regex.OfficeFa;

      // verify fa options are valid
      if (!officeFaRegex.test(v.id))
        return;

      const label = v.id;
      ddlOptions.push({label, value: v.id});
    });
  }

  switch (role.toLowerCase()){
    case RoleTypes.ROLE_FINANCIAL_ADVISOR:
    case RoleTypes.ROLE_CSA:
    case RoleTypes.ROLE_REGISTERED_CSA:
      showDropdownFaInput(true);
      setFaOptions(ddlOptions);
      setOfficeOptions([]);
      break;
    case RoleTypes.ROLE_BRANCH_MANAGER:
    case RoleTypes.ROLE_PRODUCING_BRANCH_MANAGER:
        showDropdownFaInput(true);
        setFaOptions(ddlOptions);
        setOfficeOptions(officeList);
        break;
    default:
      showDropdownFaInput(false);
      setFaOptions([]);
      setOfficeOptions([]);
      break;
  }
}

export { retrieveAccountUserSetup }


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/Helpers/index.js